<template>
  <div class="geo-tree">
    <div class="list-tree">
      <div
        class="list-tree__branch"
        v-for="region in tomatrix(regiony)"
        :key="region.locID"
      >
        <div class="d-flex f-aic">
          <template v-if="region.Miniregion">
            <span
              class="toggle-icon"
              :class="{ _open: toggle.indexOf(region.locID) >= 0 }"
              @click="toggleItem(region.locID)"
            ></span>
          </template>
          <template v-else>
            <span class="leaf-icon"></span>
          </template>
          <a
            :class="{ strong: toggle.indexOf(region.locID) >= 0 }"
            :href="region.url"
            :title="region.name"
            >{{ region.name }}</a
          >
        </div>

        <div
          class="list-tree active"
          :class="{ _open: toggle.indexOf(region.locID) >= 0 }"
        >
          <div class="pt-6">
            <div
              class="list-tree__branch ml-16"
              v-for="mregion in tomatrix(region.Miniregion)"
              :key="mregion.locID"
            >
              <div class="d-flex f-aic">
                <template v-if="mregion.Areatown">
                  <span
                    class="toggle-icon"
                    :class="{ _open: toggle.indexOf(mregion.locID) >= 0 }"
                    @click="toggleItem(mregion.locID)"
                  ></span>
                </template>
                <template v-else>
                  <span class="leaf-icon"></span>
                </template>
                <a
                  :class="{ strong: toggle.indexOf(mregion.locID) >= 0 }"
                  :href="mregion.url"
                  :title="mregion.name"
                >
                  {{ mregion.name }}</a
                >
              </div>

              <div
                class="list-tree active"
                :class="{ _open: toggle.indexOf(mregion.locID) >= 0 }"
              >
                <div class="pt-6">
                  <div
                    class="list-tree__branch ml-16"
                    v-for="aregion in tomatrix(mregion.Areatown)"
                    :key="aregion.locID"
                  >
                    <div class="d-flex f-aic">
                      <span class="leaf-icon"></span>

                      <a
                        :class="{
                          strong: toggle.indexOf(aregion.locID) >= 0
                        }"
                        :href="aregion.url"
                        :title="aregion.name"
                      >
                        {{ aregion.name }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    locid: String,
    regiony: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    toggle: []
  }),
  methods: {
    tomatrix(obj) {
      if (obj != undefined) {
        if (obj instanceof Array) {
          return obj;
        } else {
          let z = [];
          z.push(obj);
          return z;
        }
      }
      return obj;
    },
    toggleItem: function(key) {
      var i = this.toggle.indexOf(key);
      if (i < 0) {
        this.toggle.push(key);
      } else {
        this.toggle.splice(i, 1);
      }
    },
    getParent(loc, reg) {
      let that = this;

      for (let i = 0; i < reg.length; i++) {
        let el = reg[i];
        let elem = reg[i].Miniregion;

        if (elem != undefined) {
          elem = that.tomatrix(elem);
          for (let j = 0; j < elem.length; j++) {
            let el2 = elem[j];
            let elem2 = elem[j].Areatown;

            if (el2.locID == loc) {
              that.toggle.push(el.locID);
            }

            if (elem2 != undefined) {
              elem2 = that.tomatrix(elem2);
              for (let k = 0; k < elem2.length; k++) {
                let el3 = elem2[k];

                if (el3.locID == loc) {
                  that.toggle.push(el.locID, el2.locID);
                }
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    let that = this;
    this.getParent(that.locid, that.regiony);
    this.toggle.push(that.locid);
  }
};
</script>

<style lang="scss" scoped>
.geo-tree {
  @include shadow();
  border: 1px solid $border-color;
  border-radius: 4px;
  padding: 12px;
}

.list-tree {
  &__branch {
    padding: 4px 4px 4px 0;
  }

  a {
    @include text-truncate();
    color: $text-color-default;
    transition: color ease-out 0.2s;

    &:hover,
    &:focus {
      color: $blue-light;
    }
  }

  .toggle {
    color: $blue-light;
    cursor: pointer;
    padding-left: 18px;
  }

  &.active {
    max-height: 0;
    overflow: hidden;
    transition: max-height ease-out 0.15s;
  }

  &._open {
    max-height: 100vh;
    transition: max-height ease-in 0.25s;
  }
}

.toggle-icon,
.leaf-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
  position: relative;
  width: 30px;
  height: 30px;

  @media (min-width: $screen-md) {
    width: 24px;
    height: 24px;
  }

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
  }
}

.leaf-icon {
  &:before,
  &:after {
    background-color: $gray-30;
    width: 2px;
    height: 7px;
  }

  &:before {
    top: 10px;
    transform: rotate(45deg);
  }

  &:after {
    top: 6px;
    transform: rotate(-45deg);
  }
}

.toggle-icon {
  border-radius: 50%;
  cursor: pointer;
  transition: all linear 0.1s;

  &:hover {
    background-color: lighten($gray-10, 2%);
  }

  &:before,
  &:after {
    background-color: $blue-light;
    transition: all linear 0.1s;
  }

  &:before {
    width: 2px;
    height: 10px;
  }

  &:after {
    width: 10px;
    height: 2px;
  }

  &._open {
    &:before {
      height: 2px;
    }
  }
}
</style>
